// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Header: quiet centered title, no hard shadow line. */
.dpc-header::after {
  display: none;
}
.dpc-header ion-toolbar {
  --background: transparent;
  --border-width: 0;
  --min-height: 52px;
}
.dpc-header ion-title {
  padding-inline: 16px;
  font-size: 1.02rem;
  font-weight: 600;
  letter-spacing: 0.2px;
  text-align: center;
}

.dpc-content {
  --background: transparent;
  flex: 1;
}
.dpc-content::part(scroll) {
  overflow-y: auto;
}

.dpc-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 16px 12px;
}

/* Value select: filled field consistent with the anagraph form fields. */
.dpc-value {
  width: 100%;
  --background: rgba(var(--ion-color-primary-rgb), 0.05);
  --border-radius: 12px;
  border-radius: 12px;
  min-height: 52px;
}

/* Time pickers: two labeled columns, wheels on a soft branded surface. */
.dpc-times {
  display: flex;
  gap: 12px;
}

.dpc-time {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.dpc-time__label {
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: var(--ion-color-medium, #8a8a8a);
}
.dpc-time ion-datetime {
  width: 100%;
  border-radius: 14px;
  background: rgba(var(--ion-color-primary-rgb), 0.045);
  box-shadow: inset 0 0 0 1px rgba(var(--ion-color-primary-rgb), 0.1);
  --background: transparent;
  --background-rgb: transparent;
  --wheel-highlight-background: rgba(var(--ion-color-primary-rgb), 0.12);
}

/* Footer: balanced action pair, safe-area aware. */
.dpc-footer::before {
  display: none;
}

.dpc-actions {
  display: flex;
  gap: 10px;
  padding: 8px 16px calc(10px + env(safe-area-inset-bottom, 0px));
}
.dpc-actions ion-button {
  flex: 1;
  margin: 0;
  height: 46px;
  --border-radius: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  text-transform: none;
}
.dpc-actions__cancel {
  --color: var(--ion-color-medium, #8a8a8a);
}
.dpc-actions__confirm {
  --box-shadow: 0 8px 20px rgba(var(--ion-color-primary-rgb), 0.28);
}`, "",{"version":3,"sources":["webpack://./src/components/general components/day-period-change/day-period-change.component.scss","webpack://./src/components/general%20components/day-period-change/day-period-change.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;ACCF;;ADEA,uDAAA;AAEE;EACE,aAAA;ACAJ;ADGE;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;ACDJ;ADIE;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;ACFJ;;ADMA;EACE,yBAAA;EACA,OAAA;ACHF;ADKE;EACE,gBAAA;ACHJ;;ADOA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;ACJF;;ADOA,yEAAA;AACA;EACE,WAAA;EACA,sDAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;ACJF;;ADOA,yEAAA;AACA;EACE,aAAA;EACA,SAAA;ACJF;;ADOA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;ACJF;ADME;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uCAAA;ACJJ;ADOE;EACE,WAAA;EACA,mBAAA;EACA,qDAAA;EACA,mEAAA;EACA,yBAAA;EACA,6BAAA;EACA,sEAAA;ACLJ;;ADSA,mDAAA;AAEE;EACE,aAAA;ACPJ;;ADWA;EACE,aAAA;EACA,SAAA;EACA,+DAAA;ACRF;ADUE;EACE,OAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;ACRJ;ADWE;EACE,yCAAA;ACTJ;ADYE;EACE,iEAAA;ACVJ","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* Header: quiet centered title, no hard shadow line. */\n.dpc-header {\n  &::after {\n    display: none;\n  }\n\n  ion-toolbar {\n    --background: transparent;\n    --border-width: 0;\n    --min-height: 52px;\n  }\n\n  ion-title {\n    padding-inline: 16px;\n    font-size: 1.02rem;\n    font-weight: 600;\n    letter-spacing: 0.2px;\n    text-align: center;\n  }\n}\n\n.dpc-content {\n  --background: transparent;\n  flex: 1;\n\n  &::part(scroll) {\n    overflow-y: auto;\n  }\n}\n\n.dpc-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 8px 16px 12px;\n}\n\n/* Value select: filled field consistent with the anagraph form fields. */\n.dpc-value {\n  width: 100%;\n  --background: rgba(var(--ion-color-primary-rgb), 0.05);\n  --border-radius: 12px;\n  border-radius: 12px;\n  min-height: 52px;\n}\n\n/* Time pickers: two labeled columns, wheels on a soft branded surface. */\n.dpc-times {\n  display: flex;\n  gap: 12px;\n}\n\n.dpc-time {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n\n  &__label {\n    font-size: 0.72rem;\n    font-weight: 600;\n    letter-spacing: 0.6px;\n    text-transform: uppercase;\n    color: var(--ion-color-medium, #8a8a8a);\n  }\n\n  ion-datetime {\n    width: 100%;\n    border-radius: 14px;\n    background: rgba(var(--ion-color-primary-rgb), 0.045);\n    box-shadow: inset 0 0 0 1px rgba(var(--ion-color-primary-rgb), 0.1);\n    --background: transparent;\n    --background-rgb: transparent;\n    --wheel-highlight-background: rgba(var(--ion-color-primary-rgb), 0.12);\n  }\n}\n\n/* Footer: balanced action pair, safe-area aware. */\n.dpc-footer {\n  &::before {\n    display: none;\n  }\n}\n\n.dpc-actions {\n  display: flex;\n  gap: 10px;\n  padding: 8px 16px calc(10px + env(safe-area-inset-bottom, 0px));\n\n  ion-button {\n    flex: 1;\n    margin: 0;\n    height: 46px;\n    --border-radius: 13px;\n    font-weight: 600;\n    letter-spacing: 0.2px;\n    text-transform: none;\n  }\n\n  &__cancel {\n    --color: var(--ion-color-medium, #8a8a8a);\n  }\n\n  &__confirm {\n    --box-shadow: 0 8px 20px rgba(var(--ion-color-primary-rgb), 0.28);\n  }\n}\n",":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* Header: quiet centered title, no hard shadow line. */\n.dpc-header::after {\n  display: none;\n}\n.dpc-header ion-toolbar {\n  --background: transparent;\n  --border-width: 0;\n  --min-height: 52px;\n}\n.dpc-header ion-title {\n  padding-inline: 16px;\n  font-size: 1.02rem;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  text-align: center;\n}\n\n.dpc-content {\n  --background: transparent;\n  flex: 1;\n}\n.dpc-content::part(scroll) {\n  overflow-y: auto;\n}\n\n.dpc-form {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 8px 16px 12px;\n}\n\n/* Value select: filled field consistent with the anagraph form fields. */\n.dpc-value {\n  width: 100%;\n  --background: rgba(var(--ion-color-primary-rgb), 0.05);\n  --border-radius: 12px;\n  border-radius: 12px;\n  min-height: 52px;\n}\n\n/* Time pickers: two labeled columns, wheels on a soft branded surface. */\n.dpc-times {\n  display: flex;\n  gap: 12px;\n}\n\n.dpc-time {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n.dpc-time__label {\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  color: var(--ion-color-medium, #8a8a8a);\n}\n.dpc-time ion-datetime {\n  width: 100%;\n  border-radius: 14px;\n  background: rgba(var(--ion-color-primary-rgb), 0.045);\n  box-shadow: inset 0 0 0 1px rgba(var(--ion-color-primary-rgb), 0.1);\n  --background: transparent;\n  --background-rgb: transparent;\n  --wheel-highlight-background: rgba(var(--ion-color-primary-rgb), 0.12);\n}\n\n/* Footer: balanced action pair, safe-area aware. */\n.dpc-footer::before {\n  display: none;\n}\n\n.dpc-actions {\n  display: flex;\n  gap: 10px;\n  padding: 8px 16px calc(10px + env(safe-area-inset-bottom, 0px));\n}\n.dpc-actions ion-button {\n  flex: 1;\n  margin: 0;\n  height: 46px;\n  --border-radius: 13px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  text-transform: none;\n}\n.dpc-actions__cancel {\n  --color: var(--ion-color-medium, #8a8a8a);\n}\n.dpc-actions__confirm {\n  --box-shadow: 0 8px 20px rgba(var(--ion-color-primary-rgb), 0.28);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
